import { RefObject, useEffect } from 'react';
import { useChatDagDimensions } from '../../../../contexts/ChatDagDimensionsContext';

// v0.4 Task 10: per-node ResizeObserver hookup. Rich variants call
// this with the wrapperRef + their id; the singleton RO inside
// ChatDagDimensionsContext measures, coalesces via RAF, and writes
// to the dim map. Layout reads from there post-window per
// resolveDims (Task 8).
//
// clearDim on unmount prevents the dim map from holding stale
// measurements for nodes that scrolled out of focal or were replaced
// by structural changes — otherwise layout would pick up the stale
// dim the next time that id reappears in a different context.
export function useNodeDimensions(
  nodeId: string,
  ref: RefObject<HTMLElement>,
) {
  const { observe, unobserve, clearDim } = useChatDagDimensions();
  useEffect(() => {
    const el = ref.current;
    observe(nodeId, el);
    return () => {
      unobserve(nodeId, el);
      clearDim(nodeId);
    };
  }, [nodeId, observe, unobserve, clearDim, ref]);
}
